export function stringEnumToArray(e: Record<string, string>): string[] {
    return Object.keys(e).map((k) => e[k]);
}
